/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 4/27/14
 * Time: 3:11 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("templates/top-level-menu/topLevelMenuItemList.tmpl");
    var TopLevelMenuItemView = require("views/top-level-menu/TopLevelMenuItemView");

    var TopLevelMenuItemListView = Marionette.CollectionView.extend({
        template: template,
        itemView: TopLevelMenuItemView,
        events: {
            "click .top-level-menu-item": "_onMenuItemClicked"
        },
        onRender: function () {
        },
        _onMenuItemClicked: function() {
            this.trigger("item:click");
        }
    });

    return TopLevelMenuItemListView;
});